import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { MenuItem, Tax, WorkDay } from '@core/models';

export function calculateCartItemTaxes(
	item: MenuItem,
	subtotalAfterCoupon: bigint,
	precisionService: IIntegerPrecisionService,
	workDay: WorkDay
): bigint {
	const quantity = item.cantidad ?? 1n;
	const taxesForAmountExclusive =
		subtotalAfterCoupon > 0n
			? (item.impuestos
					?.filter((tax: Tax) => !tax.esPorcentaje)
					.reduce(
						(total: bigint, tax: Tax) => total + BigInt(tax.valor ?? 0n),
						0n
					) ?? 0n) * BigInt(quantity)
			: 0n;

	const taxesForPercentExclusive = (item.impuestos ?? [])
		.filter((tax: Tax) => tax.esPorcentaje)
		.reduce((total: bigint, tax: Tax) => {
			const { tax: calculatedTax } = precisionService.adjustTaxFromScaledValue(
				subtotalAfterCoupon,
				tax.valor,
				false,
				workDay
			);
			const roundedTax = precisionService.changePrecisionToInternal(
				precisionService.toScaledStringVisual(calculatedTax, workDay),
				precisionService.visualPrecision,
				workDay
			);

			return total + roundedTax;
		}, 0n);

	return taxesForAmountExclusive + taxesForPercentExclusive;
}
